var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cp",
      class: {
        "is-invalid": _vm.validate && !_vm.isValid,
        disabled: _vm.disabled,
      },
      style: {
        "margin-bottom": _vm.validate && !_vm.isValid ? "20px" : "",
      },
    },
    [
      _c("div", { staticClass: "cp-field" }, [
        _c("button", {
          staticClass: "cp-sample",
          style: { background: _vm.hex || _vm.defaultColor },
          attrs: { id: `cp-field-${_vm._uid}`, disabled: _vm.disabled },
          on: {
            click: function ($event) {
              $event.preventDefault()
            },
          },
        }),
        _c(
          "span",
          {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.toggle.apply(null, arguments)
              },
            },
          },
          [
            _c("c-input", {
              ref: "input",
              staticClass: "cp-input",
              attrs: {
                placeholder: _vm.defaultColor,
                disabled: _vm.disabled,
                "max-length": 7,
                clearable: true,
                "required-mark": true,
                required: _vm.validate && !_vm.isValid && "Неверный формат",
                "required-message":
                  _vm.validate && !_vm.isValid && "Неверный формат",
              },
              model: {
                value: _vm.hex,
                callback: function ($$v) {
                  _vm.hex = $$v
                },
                expression: "hex",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "b-popover",
        {
          ref: "color-pallete",
          attrs: {
            placement: "bottom",
            "custom-class": "cp-palette",
            target: `cp-field-${_vm._uid}`,
          },
          on: { show: _vm.onShow },
        },
        [
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("chrome-picker", {
                ref: "picker",
                staticClass: "picker",
                model: {
                  value: _vm.color,
                  callback: function ($$v) {
                    _vm.color = $$v
                  },
                  expression: "color",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }